import React, { Children, useState } from 'react';
import './faqPane.css';

export function FaqPane(props) {
    const [isOpen, setIsOpen] = useState(!!props?.isOpen);

    const toggle = () => {
        setIsOpen((v) => !v);
        window.dispatchEvent(new Event('resize'));
    };

    return (
        <section className={`faqPaneCard${isOpen ? ' is-open' : ''}`}>
            <button
                type="button"
                className="faqPaneQuestion"
                aria-expanded={isOpen}
                onClick={toggle}
            >
                <span className="faqPaneQMark" aria-hidden="true">
                    Q
                </span>
                <span className="faqPaneQuestionText">{props?.title}</span>
                <span className="faqPaneChevron" aria-hidden="true">
                    {isOpen ? '−' : '+'}
                </span>
            </button>
            {isOpen && (
                <div className="faqPaneAnswer">
                    <span className="faqPaneAMark" aria-hidden="true">
                        A
                    </span>
                    <div className="faqPaneAnswerBody">
                        {Children.map(props?.children, (child, idx) => (
                            <div className="faqPaneAnswerRow" key={idx}>
                                {child}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </section>
    );
}
